import { FileUploadItemArray } from './../models/domain/file.upload.item';
import { LiveHubResponse } from './../models/domain/livehub.response';
import { AbandonedCartItemArray } from './../models/ss-api/responses/abandoned.cart.item';
import { BillingDiscountsArray } from './../models/ss-api/responses/billing.discount.response';
import { BillingCreditsArray } from '../../app/models/ss-api/responses/billing.credits.response';
import { MobileFilesItemArray } from '../../app/models/domain/mobile.files.item';
import { Pipe, PipeTransform } from '@angular/core';
import { TicketStatusTypes } from '../models/domain/custom.ticket.item';
import { CustomTicketWidgetItem, CustomTicketWidgetItemArray } from '../models/domain/custom.ticket.widget';
import { GISProductItem } from '../models/domain/gis.product.item';
import { TOSActivityLogResponse } from '../models/ss-api/responses/tos.activity.log.response';
import { TrainingClassArray } from '../../app/models/domain/training.class';
import { NoteArray } from '../../app/models/domain/note';
import { MemberDashboardLicenseResponseArray } from '../../app/models/ss-api/responses/member.dashboard.license.response';
import { GISBundleLogArray } from '../../app/models/domain/gis.bundle.log.item';
import { GISUsageLogArray } from '../../app/models/domain/gis.usage.log';
import { InvoiceArray } from '../../app/models/domain/invoice';
import { CreditCardArray } from '../../app/models/domain/credit.card';
import { CreditItemArray } from '../../app/models/domain/credit.item';
import { ActivityItemArray } from '../../app/models/domain/activity.item';
import { AdminLogItemArray } from '../../app/models/domain/admin.log.item';
import { MemberLogItemArray } from '../../app/models/domain/member.log.item';
import { EmailLogItemBasicArray } from '../../app/models/domain/email.log.item.basics';
import { TrainingHistoryResponseArray } from '../../app/models/ss-api/responses/training.history.response';
import { EmailTemplateBasicsItemArray } from '../../app/models/domain/email.template.basics.item';
import { SalesItemArray } from '../../app/models/ss-api/responses/sales.item';
import { ToChargeItemArray } from '../../app/models/ss-api/responses/to.charge.item';
import { AutomationBillingHistoryItemArray } from '../models/ss-api/responses/automation.billing.history.item';
import { MemberBasicsItemArray } from '../models/domain/member.basics.item';
import { AuthenticationLogItemArray } from '@models/domain/authentication.log.item';
import { UpdateLogItemArray } from '@models/domain/update.log.item';
import { GlobalMACWhitelistBasicArray } from '@models/ss-api/responses/global.mac.whitelist.basic';
import { GlobalPhoneWhitelistBasicArray } from '@models/ss-api/responses/global.phone.whitelist.basic';
import { GlobalAddressWhitelistBasicArray } from '@models/ss-api/responses/global.address.whitelist.basic';

function NullValidation(item) {
    for (let property in item.Data) {
        if (item.Data.hasOwnProperty(property)) {
            if (item.Data[property] == null || item.Data[property] == undefined) item.Data[property] = '';
        }
    }
    return item;
}

@Pipe({
    name: 'filter'
})
export class FilterPipe implements PipeTransform {
    transform(items: any[], searchText: string): any[] {
        if (!items) return [];
        if (!searchText) return items;
        searchText = searchText.toLowerCase();
        return items.filter(it => {
            return it.toLowerCase().includes(searchText);
        });
    }
}

@Pipe({
    name: 'arrayFilter'
})
export class arrayFilter implements PipeTransform {
    transform(items: any[], searchText: string): any[] {

        if (items && searchText) {

            searchText = searchText.toLowerCase();

            return items.filter((item) => {
                let keys = Object.keys(item);

                for (let key of keys) {
                    let val = item[key];

                    if (typeof val === 'string' && val.toLowerCase().includes(searchText)) {
                        return item;
                    } else if (typeof val === 'number' && val.toString().toLowerCase().includes(searchText)) {
                        return item;
                    }
                }

            });

        } else {

            return items;

        }

    }

}

@Pipe({
    name: 'arrayFilterSubKeys'
})
export class arrayFilterSubKeys implements PipeTransform {
    transform(items: any[], searchText: string): any[] {
        console.log("pipx", items);
        if (items && searchText) {
            searchText = searchText.toLowerCase();
            return items.filter((item) => {
                let keys = Object.keys(item);
                for (let key of keys) {
                    let val = item[key];
                    if (typeof val === 'object' && val != null){
                        let subkeys = Object.keys(val);
                        for (let subkey of subkeys) {
                            let subval = val[subkey];
                            if (typeof subval === 'string' && subval.toLowerCase().includes(searchText)) {
                                return item;
                            } else if (typeof subval === 'number' && subval.toString().toLowerCase().includes(searchText)) {
                                return item;
                            }
                        }      
                    }
                    else if (typeof val === 'string' && val.toLowerCase().includes(searchText)) {
                        return item;
                    } else if (typeof val === 'number' && val.toString().toLowerCase().includes(searchText)) {
                        return item;
                    }
                }
            });
        } else {
            return items;
        }
    }
}

@Pipe({
    name: 'filterByTicketStatus'
})
export class FilterByTicketStatusPipe implements PipeTransform {
    transform(items: CustomTicketWidgetItem[], args: TicketStatusTypes[]): CustomTicketWidgetItem[] {
        if (items == undefined)
            return
        if (args == undefined)
            return items;

        if (items) {
            let resultArray: CustomTicketWidgetItem[] = [];
            if (args.length === 0) {
                resultArray = items;
            } else {
                for (let item of items) {
                    let keepGoing: boolean = true;
                    args.forEach(a => {
                        if (item.Status != null && item.Status == a && keepGoing) {
                            resultArray.push(item);
                            keepGoing = false;
                            return;
                        }
                    });

                }
            }

            return resultArray;
        } else {
            return null;
        }


    }
}


@Pipe({
    name: 'filterGISCredits'
})
export class FilterGISCreditsPipe implements PipeTransform {
    transform(items: GISProductItem[], args: number): GISProductItem[] {
        if (!items) return [];
        if (!args) return items;
        // args = args.toLowerCase();
        return items.filter(it => {
            if (it.ProductID == Number(args))
                return it;
        });
    }
}

// --------------------------------------------------- tosIPFilter

@Pipe({
    name: 'tosIPFilter',
})
export class tosIPFilterPipe implements PipeTransform {
    transform(items: TOSActivityLogResponse[], searchIP: string, searchMAC: string, searchPCName: string): TOSActivityLogResponse[] {
        if (!items) return [];
        if (!searchIP) return items;


        return items.filter(item => {
            if (item.AuditLog != undefined) {

                if (item.AuditLog.IP.toLowerCase().includes(searchIP)) return item;

            } else if (item.TransferLog != undefined) {

                // return item;

            } else {
                return;
            }

        });
    }
}

// --------------------------------------------------- trainingClassFilter

@Pipe({
    name: 'trainingClassFilter',
})
export class trainingClassFilter implements PipeTransform {
    transform(items: TrainingClassArray, searchTerm: string): TrainingClassArray {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new TrainingClassArray();

        array.LastSort = items.LastSort;

        items.forEach(function (item) {
            item = NullValidation(item);
            if (item.ClassName.toLowerCase().includes(term) || item.ClassTitle.toLowerCase().includes(term)) {
                array.push(item);
            }
        })

        return array;
    }
}


// --------------------------------------------------- noteFilter

@Pipe({
    name: 'noteFilter',
})
export class noteFilter implements PipeTransform {
    transform(items: NoteArray, searchTerm: string): NoteArray {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new NoteArray();

        array.LastSort = items.LastSort;

        items.forEach(function (item) {
            item = NullValidation(item);
            if (item.AdminName.toLowerCase().includes(term) || item.Note.toLowerCase().includes(term) || item.MemberFullName.toLowerCase().includes(term)) {
                array.push(item);
            }
        })

        return array;
    }
}


// --------------------------------------------------- ownLicenseFilter

@Pipe({
    name: 'ownLicenseFilter',
})
export class ownLicenseFilter implements PipeTransform {
    transform(items: MemberDashboardLicenseResponseArray, searchTerm: string): MemberDashboardLicenseResponseArray {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new MemberDashboardLicenseResponseArray();

        array.LastSort = items.LastSort;

        items.forEach(function (item) {
            item = NullValidation(item);
            if (item.Product.toLowerCase().includes(term) || item.Key.toLowerCase().includes(term)) {
                array.push(item);
            }
        })

        return array;
    }
}


// --------------------------------------------------- designerLicenseFilter

@Pipe({
    name: 'designerLicenseFilter',
})
export class designerLicenseFilter implements PipeTransform {
    transform(items: MemberDashboardLicenseResponseArray, searchTerm: string): MemberDashboardLicenseResponseArray {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new MemberDashboardLicenseResponseArray();

        array.LastSort = items.LastSort;

        items.forEach(function (item) {
            item = NullValidation(item);
            if (item.Product.toLowerCase().includes(term) || item.Key.toLowerCase().includes(term) || item.MemberFirstName.toLowerCase().includes(term) || item.MemberLastName.toLowerCase().includes(term)) {
                array.push(item);
            }
        })

        return array;
    }
}


// --------------------------------------------------- creditBundleFilter

@Pipe({
    name: 'creditBundleFilter',
})
export class creditBundleFilter implements PipeTransform {
    transform(items: GISBundleLogArray, searchTerm: string): GISBundleLogArray {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new GISBundleLogArray();

        array.LastSort = items.LastSort;

        items.forEach(function (item) {
            item = NullValidation(item);
            if (item.Description.toLowerCase().includes(term) || item.BundleCredits == Number(term)) {
                array.push(item);
            }
        })

        return array;
    }
}


// --------------------------------------------------- creditUsageFilter

@Pipe({
    name: 'creditUsageFilter',
})
export class creditUsageFilter implements PipeTransform {
    transform(items: GISUsageLogArray, searchTerm: string): GISUsageLogArray {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new GISUsageLogArray();

        array.LastSort = items.LastSort;

        items.forEach(function (item) {
            item = NullValidation(item);
            if (item.Address.toLowerCase().includes(term) || item.LicenseKey.toLowerCase().includes(term)) {
                array.push(item);
            }
        })

        return array;
    }
}


// --------------------------------------------------- invoiceFilter

@Pipe({
    name: 'invoiceFilter',
})
export class invoiceFilter implements PipeTransform {
    transform(items: InvoiceArray, searchTerm: string): InvoiceArray {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new InvoiceArray();

        array.LastSort = items.LastSort;

        items.forEach(function (item) {
            item = NullValidation(item);
            if (!item.LicenseKey) item.LicenseKey = '';

            if (item.LicenseKey.toLowerCase().includes(term) || item.InvoiceNumber.toLowerCase().includes(term) || item.Items[0].Description.toLowerCase().includes(term) || item.Total == Number(term) || item.TotalDue == Number(term) || item.TotalPaid == Number(term) || item.SubTotal == Number(term)) {
                array.push(item);
            }
        })

        return array;
    }
}


// --------------------------------------------------- creditCardFilter

@Pipe({
    name: 'creditCardFilter',
})
export class creditCardFilter implements PipeTransform {
    transform(items: CreditCardArray, searchTerm: string): CreditCardArray {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new CreditCardArray();

        array.LastSort = items.LastSort;

        items.forEach(function (item) {
            item = NullValidation(item);
            if (item.FirstName.toLowerCase().includes(term) || item.LastName.toLowerCase().includes(term) || item.LastFour.toLowerCase().includes(term)) {
                array.push(item);
            }
        })

        return array;
    }
}



// --------------------------------------------------- creditFilter

@Pipe({
    name: 'creditFilter',
})
export class creditFilter implements PipeTransform {
    transform(items: CreditItemArray, searchTerm: string): CreditItemArray {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new CreditItemArray();

        array.LastSort = items.LastSort;

        items.forEach(function (item) {
            item = NullValidation(item);
            if (item.Description.toLowerCase().includes(term) || item.Amount == Number(term)) {
                array.push(item);
            }
        })

        return array;
    }
}

// --------------------------------------------------- activityFilter

@Pipe({
    name: 'activityFilter',
})
export class activityFilter implements PipeTransform {
    transform(items: ActivityItemArray, searchTerm: string): ActivityItemArray {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new ActivityItemArray();

        items.forEach(function (item) {
            item = NullValidation(item);
            switch (item.ActivityType) {
                case 0:
                    if (item.Data.Note.toLowerCase().includes(term) || item.Data.RelationInfo.toLowerCase().includes(term)) {
                        array.push(item);
                    }
                    break;
                case 1:
                    if (item.Data.Subject.toLowerCase().includes(term) || item.Data.Description.toLowerCase().includes(term) || item.Data.FullName.toLowerCase().includes(term)) {
                        array.push(item);
                    }
                    break;
                case 2:
                    if (!item.Data.LicenseKey) item.Data.LicenseKey = '';
                    if (item.Data.Subject.toLowerCase().includes(term) || item.Data.Description.toLowerCase().includes(term) || item.Data.AdminFullName.toLowerCase().includes(term) || item.Data.LicenseKey.toLowerCase().includes(term)) {
                        array.push(item);
                    }
                    break;
                case 3:
                    if (item.Data.Subject.toLowerCase().includes(term) || item.Data.AdminName.toLowerCase().includes(term) || item.Data.FromEmail.toLowerCase().includes(term) || item.Data.ToEmail.toLowerCase().includes(term)) {
                        array.push(item);
                    }
                    break;
                case 4:
                    if (item.Data.Subject.toLowerCase().includes(term) || item.Data.FirstMessage.toLowerCase().includes(term) || item.Data.Name.toLowerCase().includes(term)) {
                        array.push(item);
                    }
                    break;
            }
        })

        return array;
    }
}



// --------------------------------------------------- adminLogFilter

@Pipe({
    name: 'adminLogFilter',
})
export class adminLogFilter implements PipeTransform {
    transform(items: AdminLogItemArray, searchTerm: string): AdminLogItemArray {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new AdminLogItemArray();

        array.LastSort = items.LastSort;

        items.forEach(function (item) {
            item = NullValidation(item);
            if (!item.LicenseKey) item.LicenseKey = ''
            if (item.Description.toLowerCase().includes(term) || item.LicenseKey.toLowerCase().includes(term) || item.AdminFullName.toLowerCase().includes(term) || item.Subject.toLowerCase().includes(term)) {
                array.push(item);
            }
        })

        return array;
    }
}



// --------------------------------------------------- memberLogFilter

@Pipe({
    name: 'memberLogFilter',
})
export class memberLogFilter implements PipeTransform {
    transform(items: MemberLogItemArray, searchTerm: string): MemberLogItemArray {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new MemberLogItemArray();

        array.LastSort = items.LastSort;

        items.forEach(function (item) {
            item = NullValidation(item);
            if (!item.LicenseKey) item.LicenseKey = ''
            if (item.Description.toLowerCase().includes(term) || item.LicenseKey.toLowerCase().includes(term) || item.Subject.toLowerCase().includes(term)) {
                array.push(item);
            }
        })

        return array;
    }
}

@Pipe({
    name: 'authenticationLogFilter',
})
export class authenticationLogFilter implements PipeTransform {
    transform(items: AuthenticationLogItemArray, searchTerm: string): AuthenticationLogItemArray {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new AuthenticationLogItemArray();

        array.LastSort = items.LastSort;

        items.forEach(function (item) {
            item = NullValidation(item);
            if (item.IP.toLowerCase().includes(term)) {
                array.push(item);
            }
        })

        return array;
    }
}

@Pipe({
    name: 'updateLogFilter',
})
export class updateLogFilter implements PipeTransform {
    transform(items: UpdateLogItemArray, searchTerm: string): UpdateLogItemArray {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new UpdateLogItemArray();

        array.LastSort = items.LastSort;

        items.forEach(function (item) {
            item = NullValidation(item);
            if (item.LicenseKey.toLowerCase().includes(term)) {
                array.push(item);
            }
        })

        return array;
    }
}

// --------------------------------------------------- emailLogFilter

@Pipe({
    name: 'emailLogFilter',
})
export class emailLogFilter implements PipeTransform {
    transform(items: EmailLogItemBasicArray, searchTerm: string): EmailLogItemBasicArray {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new EmailLogItemBasicArray();

        array.LastSort = items.LastSort;

        items.forEach(function (item) {
            item = NullValidation(item);
            if (item.Subject.toLowerCase().includes(term) || item.ToEmail.toLowerCase().includes(term)) {
                array.push(item);
            }
        })

        return array;
    }
}


// --------------------------------------------------- trainingHistoryFilter

@Pipe({
    name: 'trainingHistoryFilter',
})
export class trainingHistoryFilter implements PipeTransform {
    transform(items: TrainingHistoryResponseArray, searchTerm: string): TrainingHistoryResponseArray {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new TrainingHistoryResponseArray();

        array.LastSort = items.LastSort;

        items.forEach(function (item) {
            item = NullValidation(item);
            if (item.ClassName.toLowerCase().includes(term) || item.ClassTitle.toLowerCase().includes(term) || item.LicenseKey.toLowerCase().includes(term) || item.ProductName.toLowerCase().includes(term)) {
                array.push(item);
            }
        })

        return array;
    }
}



// --------------------------------------------------- emailTemplatesListFilter

@Pipe({
    name: 'emailTemplatesListFilter',
})
export class emailTemplatesListFilter implements PipeTransform {
    transform(items: EmailTemplateBasicsItemArray, searchTerm: string): EmailTemplateBasicsItemArray {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new EmailTemplateBasicsItemArray();

        array.LastSort = items.LastSort;

        items.forEach(function (item) {
            item = NullValidation(item);
            if (item.Name.toLowerCase().includes(term)) {
                array.push(item);
            }
        })

        return array;
    }
}



// --------------------------------------------------- orderReportFilter

@Pipe({
    name: 'orderReportFilter',
})
export class orderReportFilter implements PipeTransform {
    transform(items: SalesItemArray, searchTerm: string): SalesItemArray {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new SalesItemArray();

        array.LastSort = items.LastSort;

        items.forEach(function (item) {
            item = NullValidation(item);
            if (item.MemberName.toLowerCase().includes(term) || item.LicenseKey.toLowerCase().includes(term) || item.ProductName.toLowerCase().includes(term) || item.CompanyName.toLowerCase().includes(term)) {
                array.push(item);
            }
        })

        return array;
    }
}



// --------------------------------------------------- toChargeItemFilter

@Pipe({
    name: 'toChargeItemFilter',
})
export class toChargeItemFilter implements PipeTransform {
    transform(items: ToChargeItemArray, searchTerm: string): ToChargeItemArray {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new ToChargeItemArray();

        array.LastSort = items.LastSort;

        items.forEach(function (item) {
            item = NullValidation(item);
            if (item.FirstName.toLowerCase().includes(term) || item.LicenseKey.toLowerCase().includes(term) || item.LastName.toLowerCase().includes(term) || item.Company.toLowerCase().includes(term) || item.Amount.toString().includes(term) || (item.CCLast4 && item.CCLast4.toString().includes(term))) {
                array.push(item);
            }
        })

        return array;
    }
}



// --------------------------------------------------- yardFilesFilter

@Pipe({
    name: 'yardFilesFilter',
})
export class yardFilesFilter implements PipeTransform {
    transform(items: MobileFilesItemArray, searchTerm: string): MobileFilesItemArray {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new MobileFilesItemArray();

        array.LastSort = items.LastSort;

        items.forEach(function (item) {
            item = NullValidation(item);
            if (item.CreatedDate.toString().toLowerCase().includes(term) || item.LicenseKey.toLowerCase().includes(term) || item.Title.toLowerCase().includes(term) || item.DeviceID.toLowerCase().includes(term) || item.UUID.toString().includes(term) || item.FileName.toLowerCase().includes(term)) {
                array.push(item);
            }
        })

        return array;
    }
}


// --------------------------------------------------- invoiceReportFilter

@Pipe({
    name: 'invoiceReportFilter',
})
export class invoiceReportFilter implements PipeTransform {
    transform(items: InvoiceArray, searchTerm: string): InvoiceArray {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new InvoiceArray();

        array.LastSort = items.LastSort;

        items.forEach(function (item) {
            item = NullValidation(item);
            if (item.Company.toString().toLowerCase().includes(term)
                || item.FirstName.toString().toLowerCase().includes(term)
                || item.LastName.toString().toLowerCase().includes(term)
                || (item.PaymentTransactions.length > 0 && item.PaymentTransactions[0].GatewayTransactionID.toString().toLowerCase().includes(term))
                || (item.LicenseKey && item.LicenseKey.toString().toLowerCase().includes(term))
                || item.Email.toString().toLowerCase().includes(term)) {
                array.push(item);
            }
        })

        return array;
    }
}


// --------------------------------------------------- creditReportFilter

@Pipe({
    name: 'creditReportFilter',
})
export class creditReportFilter implements PipeTransform {
    transform(items: BillingCreditsArray, searchTerm: string): BillingCreditsArray {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new BillingCreditsArray();

        array.LastSort = items.LastSort;

        items.forEach(function (item) {
            item = NullValidation(item);
            if (item.FirstName.toString().toLowerCase().includes(term)
                || item.Email.toString().toLowerCase().includes(term)
                || item.LastName.toString().toLowerCase().includes(term)
                || item.Credit.toString().toLowerCase().includes(term)) {
                array.push(item);
            }
        })

        return array;
    }
}

// --------------------------------------------------- discountReportFilter

@Pipe({
    name: 'discountReportFilter',
})
export class discountReportFilter implements PipeTransform {
    transform(items: BillingDiscountsArray, searchTerm: string): BillingDiscountsArray {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new BillingDiscountsArray();

        array.LastSort = items.LastSort;

        items.forEach(function (item) {
            item = NullValidation(item);
            if (item.FirstName.toString().toLowerCase().includes(term)
                || item.Email.toString().toLowerCase().includes(term)
                || item.LastName.toString().toLowerCase().includes(term)
                || (item.Company && item.Company.toString().toLowerCase().includes(term))
                || item.LicenseKey.toString().toLowerCase().includes(term)
                || item.InvoiceDescription.toString().toLowerCase().includes(term)
                || (item.Reason && item.Reason.toString().toLowerCase().includes(term))) {
                array.push(item);
            }
        })

        return array;
    }
}



// --------------------------------------------------- automatedBillingFilter

@Pipe({
    name: 'automatedBillingFilter',
})
export class automatedBillingFilter implements PipeTransform {
    transform(items: AutomationBillingHistoryItemArray, searchTerm: string): AutomationBillingHistoryItemArray {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new AutomationBillingHistoryItemArray();

        array.LastSort = items.LastSort;

        items.forEach(function (item) {
            item = NullValidation(item);
            if (item.MemberName.toString().toLowerCase().includes(term)
                || item.Invoice.InvoiceNumber.toString().toLowerCase().includes(term)
                || item.Invoice.CreditCardLast4.toString().toLowerCase().includes(term)
                || item.LicenseKey.toString().toLowerCase().includes(term)
                || item.DesignerName.toString().toLowerCase().includes(term)
                || (item.Invoice.PaymentTransactions[0] && item.Invoice.PaymentTransactions[0].GatewayTransactionID.toString().toLowerCase().includes(term))
                || item.Action.toString().toLowerCase().includes(term)
                || item.RoutineName.toString().toLowerCase().includes(term)) {
                array.push(item);
            }
        })

        return array;
    }
}


// --------------------------------------------------- abandonedCartFilter

@Pipe({
    name: 'abandonedCartFilter',
})
export class abandonedCartFilter implements PipeTransform {
    transform(items: AbandonedCartItemArray, searchTerm: string): AbandonedCartItemArray {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new AbandonedCartItemArray();

        array.LastSort = items.LastSort;

        items.forEach(function (item) {
            item = NullValidation(item);
            if (item.FirstName.toString().toLowerCase().includes(term)
                || item.LastName.toString().toLowerCase().includes(term)
                || item.Address.toString().toLowerCase().includes(term)
                || item.Company.toString().toLowerCase().includes(term)
                || item.City.toString().toLowerCase().includes(term)
                || item.State.toString().toLowerCase().includes(term)
                || item.ZipCode.toString().toLowerCase().includes(term)
                || item.Email.toString().toLowerCase().includes(term)
                || item.Country.toString().toLowerCase().includes(term)) {
                array.push(item);
            }
        })

        return array;
    }
}

// --------------------------------------------------- macFilter

@Pipe({
    name: 'macFilter',
})
export class macFilter implements PipeTransform {
    transform(items: GlobalMACWhitelistBasicArray, searchTerm: string): GlobalMACWhitelistBasicArray {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new GlobalMACWhitelistBasicArray();

        array.LastSort = items.LastSort;

        items.forEach(function (item) {
            item = NullValidation(item);
            if (item.MACAddress.toString().toLowerCase().includes(term)) {
                array.push(item);
            }
        })

        return array;
    }
}

// --------------------------------------------------- phoneWhitelistFilter

@Pipe({
    name: 'phoneWhitelistFilter',
})
export class phoneWhitelistFilter implements PipeTransform {
    transform(items: GlobalPhoneWhitelistBasicArray, searchTerm: string): GlobalPhoneWhitelistBasicArray {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new GlobalPhoneWhitelistBasicArray();

        array.LastSort = items.LastSort;

        items.forEach(function (item) {
            item = NullValidation(item);
            if (item.Phone.toString().toLowerCase().includes(term)) {
                array.push(item);
            }
        })

        return array;
    }
}

// --------------------------------------------------- addressWhitelistFilter

@Pipe({
    name: 'addressWhitelistFilter',
})
export class addressWhitelistFilter implements PipeTransform {
    transform(items: GlobalAddressWhitelistBasicArray, searchTerm: string): GlobalAddressWhitelistBasicArray {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new GlobalAddressWhitelistBasicArray();

        array.LastSort = items.LastSort;

        items.forEach(function (item) {
            item = NullValidation(item);
            if (item.Address.toString().toLowerCase().includes(term)
                || item.FuzzyAddress.toString().toLowerCase().includes(term)
                || item.City.toString().toLowerCase().includes(term)
                || item.State.toString().toLowerCase().includes(term)
                || item.ZipCode.toString().toLowerCase().includes(term)
                || item.Country.toString().toLowerCase().includes(term)) {
                array.push(item);
            }
        })

        return array;
    }
}

// --------------------------------------------------- ticketFilter

@Pipe({
    name: 'ticketFilter',
})
export class ticketFilter implements PipeTransform {
    transform(items: CustomTicketWidgetItemArray, searchTerm: string): CustomTicketWidgetItemArray {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new CustomTicketWidgetItemArray();

        items.forEach(function (item) {
            item = NullValidation(item);
            if (item.MemberName.toString().toLowerCase().includes(term)
                || item.Subject.toString().toLowerCase().includes(term)
                || item.Body.toString().toLowerCase().includes(term)) {
                array.push(item);
            }
        })

        return array;
    }
}



// --------------------------------------------------- TOSOffendors

@Pipe({
    name: 'tosOffendorFilter',
})
export class tosOffendorFilter implements PipeTransform {
    transform(items: MemberBasicsItemArray, searchTerm: string): MemberBasicsItemArray {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new MemberBasicsItemArray();

        items.forEach(function (item) {
            item = NullValidation(item);
            if (item.Name.toString().toLowerCase().includes(term)
            || item.ID.toString().toLowerCase().includes(term)) {
                array.push(item);
            }
        })

        return array;
    }
}



// --------------------------------------------------- clientFilesFilter

@Pipe({
    name: 'clientFilesFilter',
})
export class clientFilesFilter implements PipeTransform {
    transform(items: LiveHubResponse, searchTerm: string): LiveHubResponse {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new LiveHubResponse();

        items.forEach(function (item) {
            item = NullValidation(item);
            if (item.fullName && item.fullName.toString().toLowerCase().includes(term)) {
                array.push(item);
            } else if (item.name && item.name.toString().toLowerCase().includes(term)) {
                array.push(item);
            }
        })

        return array;
    }
}



// --------------------------------------------------- uploadedFilesFilter

@Pipe({
    name: 'uploadedFilesFilter',
})
export class uploadedFilesFilter implements PipeTransform {
    transform(items: FileUploadItemArray, searchTerm: string): LiveHubResponse {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new LiveHubResponse();

        items.forEach(function (item) {
            item = NullValidation(item);
            if (item.FilePath.toString().toLowerCase().includes(term) || item.LicenseKey.toString().toLowerCase().includes(term)) {
                array.push(item);
            }
        })

        return array;
    }
}


// --------------------------------------------------- uploadedLogsFilter

@Pipe({
    name: 'uploadedLogsFilter',
})
export class uploadedLogsFilter implements PipeTransform {
    transform(items: FileUploadItemArray, searchTerm: string): LiveHubResponse {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new LiveHubResponse();

        items.forEach(function (item) {
            item = NullValidation(item);
            if (item.FilePath.toString().toLowerCase().includes(term) || item.LicenseKey.toString().toLowerCase().includes(term)) {
                array.push(item);
            }
        })

        return array;
    }
}


// --------------------------------------------------- registryFilter

@Pipe({
    name: 'registryFilter',
})
export class registryFilter implements PipeTransform {
    transform(items: Array<any>, searchTerm: string): Array<any> {
        if (!items) return;
        if (!searchTerm) return items;

        let term = searchTerm.toLowerCase();
        let array = new Array<any>();

        items.forEach(function (item) {
            item = NullValidation(item);
            if (item.valueName.toString().toLowerCase().includes(term) || item.value.toString().toLowerCase().includes(term)) {
                array.push(item);
            }
        })

        return array;
    }
}
